import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { BeVeiculo } from 'src/app/models/BeVeiculo';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-veiculos-sem-usuario',
  templateUrl: './list-veiculos-sem-usuario.component.html',
  styleUrls: ['./list-veiculos-sem-usuario.component.css']
})
export class ListVeiculosSemUsuarioComponent implements OnInit, OnDestroy {
  public veiculos: BeVeiculo[] = [];
  public colunas: ListaDadosColuna[] = [
    { campo: 'dsMarca', rotulo: 'Marca', tamanho: '16%' },
    { campo: 'dsModelo', rotulo: 'Modelo', tamanho: '22%' },
    { campo: 'dsCor', rotulo: 'Cor', tamanho: '12%' },
    { campo: 'dsAnoFabricacao', rotulo: 'Ano Fabricação', tamanho: '14%' },
    { campo: 'dsAnoModelo', rotulo: 'Ano Modelo', tamanho: '14%' },
    { campo: 'dsPlaca', rotulo: 'Placa', tamanho: '14%' }
  ];
  public subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) { }

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BeVeiculo[]>(
      `/api/Veiculos/ListarVeiculosSemUsuario`
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.onResult(res);
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onEdit(veiculo: BeVeiculo) {
    this.router.navigate(['/veiculo', veiculo.idVeiculo], { relativeTo: this.route });
  }

  public onDelete(veiculo: BeVeiculo) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', veiculo);
  }

  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', veiculo: BeVeiculo = {} as BeVeiculo) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/Veiculos/${veiculo.idVeiculo}`),
          () => this.onDeleteConfirm(veiculo),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private onResult(res: BeVeiculo[]) {
    this.veiculos = res ?? [];
  }

  private onDeleteConfirm(res: BeVeiculo) {
    this.veiculos = this.veiculos.filter(veiculo => veiculo.idVeiculo !== res.idVeiculo);
    this.snackBarService.exibirSucesso('Registro excluído!');
  }
}
